import { render, staticRenderFns } from "./provider-edit.vue?vue&type=template&id=21a8374c"
import script from "./provider-edit.vue?vue&type=script&lang=js"
export * from "./provider-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports